import { useState } from 'react'
import { errorMessage } from '../lib/api'
import { useAddIntegration, useConnectors } from '../lib/hooks'

/** Adds a booking system to this park, picked from the connectors the API has registered. */
export default function AddIntegration({ slug, existing }: { slug: string; existing: string[] }) {
  const [connector, setConnector] = useState('')
  const connectors = useConnectors()
  const add = useAddIntegration(slug)

  return (
    <section className="card">
      <h2>Koppeling toevoegen</h2>
      {connectors.isPending && <p className="muted small">Boekingssystemen laden…</p>}
      {connectors.isError && (
        <p className="inline-error">
          {errorMessage(connectors.error)}{' '}
          <button type="button" className="btn link" onClick={() => void connectors.refetch()}>
            Opnieuw proberen
          </button>
        </p>
      )}
      {connectors.data && connectors.data.length === 0 && (
        <p className="muted small">Deze installatie kent nog geen boekingssystemen.</p>
      )}
      {connectors.data && connectors.data.length > 0 && (
        <form
          className="actions"
          style={{ marginTop: 0 }}
          onSubmit={(event) => {
            event.preventDefault()
            if (connector !== '') add.mutate(connector, { onSuccess: () => setConnector('') })
          }}
        >
          <label className="check">
            <span className="visually-hidden">Boekingssysteem</span>
            <select value={connector} onChange={(event) => setConnector(event.target.value)}>
              <option value="">kies een boekingssysteem…</option>
              {connectors.data.map((item) => (
                <option key={item.key} value={item.key}>
                  {item.label}
                  {existing.includes(item.key) ? ' (al gekoppeld)' : ''}
                </option>
              ))}
            </select>
          </label>
          <button type="submit" className="btn primary" disabled={connector === '' || add.isPending}>
            {add.isPending ? 'Toevoegen…' : 'Toevoegen'}
          </button>
          {add.isError && <span className="inline-error">{errorMessage(add.error)}</span>}
        </form>
      )}
    </section>
  )
}
